import React, { useCallback, useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { Form, Image } from "react-bootstrap";
import { useApi } from "../api/contexts/ApiContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
interface Facility {
    id: number,
    contract_number: number,
    name: string,
    contract_start_date: string,
    pref: string,
    address: string,
    contract_type: string,
    category: number,
    usage_total: number,
    contract_usage: number,
    annual_load_factor_p: number,
    annual_load_factor_h: number,
    option_1: string,
    option_2: string,
    option_3: string,
    option_4: string,
    min_bid_amount: number,
    note: string,
    data_file_name: string,
    data_file_path: string,
    supplier_id: number,
    supplier: {
        name: string,
    }
    reseller: {
        name: string,
    },
    [key: string]: any;
}

interface OpportunityStructure {
    id: number,
    due: string,
    close_data: Date,
    company_id: number,
    name: string,
    industry: string,
    bids: {
        bid_id: number,
        status: number,
        upload_file_path: string,
        upload_file_name: string
    }[];
}

const Contact: React.FC = () => {
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const [isConfirm, setIsConfirm] = useState(false);
    const [question, setQuestion] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [facilities, setFacilities] = useState<Facility[]>([]);
    const [checkedFacilities, setCheckedFacilities] = useState<Record<number | string, boolean>>({});
    const location = useLocation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const opportunityId: number = parseInt(queryParams.get('opportunity_id') || '0', 10);
    const navigate = useNavigate();
    const { getModule } = useApi();

    const handleCheckboxChange = (facilityId: number | string) => {
        if (facilityId === 'all') {
            const newAllChecked = !checkedFacilities['all'];
            // const allChecked = Object.values(checkedFacilities).every((checked: boolean) => checked);
            setCheckedFacilities(facilities.reduce((acc: Record<number | string, boolean>, facility: Facility) => {
                acc[facility.id] = newAllChecked;
                acc['all'] = newAllChecked;
                return acc;
            }, {}));
        } else {
            setCheckedFacilities((prevState: Record<number | string, boolean>) => {
                const newCheckedState = {
                    ...prevState,
                    [facilityId]: !prevState[facilityId]
                };

                const allChecked = facilities.every(facility => newCheckedState[facility.id]);
                newCheckedState['all'] = allChecked;

                return newCheckedState;
            });
        }
    };

    const handleGoConfirm = (isConfirm: boolean) => {
        if (!title.trim() || !question.trim() || !Object.values(checkedFacilities).some(checked => checked)) {
            alert('必須項目を全て入力してください。');
            return;
        }

        setIsConfirm(isConfirm);
    }

    const fetchFacilityByOpportunityId = useCallback(async () => {
        const FacilityApi = await getModule('FacilityApi');
        const response = await FacilityApi.getFacilityByOpportunityId({ opportunity_id: opportunityId });
        return response.data as Facility[];
    }, [opportunityId, getModule]);

    const fetchData = useCallback(async () => {
        const facilities: Facility[] = await fetchFacilityByOpportunityId();
        setFacilities(facilities);

        if (Object.keys(checkedFacilities).length === 0) {
            setCheckedFacilities(facilities.reduce((acc: Record<number, boolean>, facility: Facility) => {
                acc[facility.id] = false;
                return acc;
            }, {}));
        }
    }, [fetchFacilityByOpportunityId]);
    const handleSubmit = async () => {
        if (isSubmitting) return; // 2回押し防止
        setIsSubmitting(true);
        const GeneralApi = await getModule('GeneralApi');
        const { all, ...filteredCheckedFacilities } = checkedFacilities;
        const response = await GeneralApi.saveQuestion({
            user_id: userInfo?.id.toString() || '',
            vendor_id: vendorInfo?.vendor_id.toString() || '',
            title: title,
            opportunity_id: opportunityId,
            facilityKey: filteredCheckedFacilities,
            question: question,
        });

        if (response.status === 'success') {
            navigate('/contact_completed', { state: { opportunityId: opportunityId } });
            return;
        }
        alert('問い合わせに失敗しました。');
        setIsSubmitting(false);

    };

    useEffect(() => {
        setIsLoading(true);
        fetchData().then(() => {
            setIsLoading(false);
        });
    }, [fetchData]);

    return (
        <>

            <section className="section-name project-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-10 mx-auto">
                            <div className="login-wrapper py-lg-5 py-3 text-center">
                                <Image className="height-90 mb-2" src="assets/images/title-inquiry.svg" />
                                <div className="text-md mb-sm-4 mb-3 fw-400">問い合わせ内容を入力</div>

                                {isLoading ? <div className="d-flex justify-content-center align-items-center mb-5" style={{ height: '100%' }}>
                                    <Spinner animation="border" variant="primary" />
                                </div> :
                                    <Form className="form-theme focus-off" id="contact-form" action="contact_confirm" method="post">
                                        <div className="border-bottom-5-blue-04"></div>
                                        <div className="bg-ass-demo p-lg-5 p-3 mb-lg-5 mb-4">
                                            <div className="col-lg-11 col-11 px-0 mx-auto">
                                                <Form.Group className="form-group text-left mb-4">
                                                    <Form.Label htmlFor="name1">件名<Image className="img img-fluid required-icon"
                                                        src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                    {
                                                        isConfirm ? <p>{title}</p> :
                                                            <Form.Control type="text" name="title" className="form-control rounded-0 bg-white"
                                                                id="name1" placeholder="件名を入力してください" required
                                                                value={title}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
                                                            />
                                                    }
                                                </Form.Group>
                                                <div className="form-group text-left mb-3">
                                                    <label htmlFor="name33" className="line_label">問い合わせる施設(複数設定可)
                                                        <img className="img img-fluid required-icon"
                                                            src="assets/images/registration/required-icon.svg" />
                                                    </label>
                                                    <div className="checkbox mr-3">
                                                        <label>
                                                            <input type="checkbox" value="全施設" id="all"
                                                                checked={checkedFacilities['all']}
                                                                onChange={() => handleCheckboxChange('all')}
                                                                disabled={isConfirm ? true : false}
                                                            />
                                                            <span className="checkmark"></span>
                                                            全施設
                                                        </label>
                                                    </div>
                                                    <div className="input-group form-check-cus">
                                                        {

                                                            facilities.map((facility) => (
                                                                <div key={facility.id} className="checkbox mr-3">
                                                                    <label>
                                                                        <input className="children" type="checkbox" name="selected[]"
                                                                            value={facility.name} checked={checkedFacilities[facility.id]}
                                                                            onChange={() => handleCheckboxChange(facility.id)}
                                                                            disabled={isConfirm ? true : false} />
                                                                        <span className="checkmark"></span>
                                                                        {facility.name}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>

                                                <Form.Group className="form-group text-left">
                                                    <Form.Label htmlFor="name2">内容<Image className="img img-fluid required-icon"
                                                        src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                    {
                                                        isConfirm ? <p>{question}</p> : <textarea name="body" className="form-control rounded-0 bg-white" id="name2"
                                                            placeholder="問い合わせ内容を入力してください" rows={7}
                                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setQuestion(e.target.value)}
                                                            required>{question}</textarea>
                                                    }
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="py-3 mb-3 text-center">
                                            {
                                                isConfirm ? <>
                                                    <button type="button" className={`btn btn-theme btn-danger rounded-pill px-5 mr-2`} id="next"
                                                        onClick={handleSubmit}
                                                        disabled={isSubmitting}
                                                    ><span className="mx-3">送信</span></button>
                                                    <button type="button"
                                                        className="btn btn-theme btn-secondary rounded-pill px-4" onClick={() => setIsConfirm(false)}>前の画面に戻る</button>
                                                </>
                                                    :
                                                    <>
                                                        <button type="button" className="btn btn-theme btn-danger rounded-pill px-5 mr-2" id="next"
                                                            onClick={() => handleGoConfirm(true)}><span className="mx-3">次へ</span></button>
                                                        <button type="button"
                                                            className="btn btn-theme btn-secondary rounded-pill px-4" onClick={() => navigate(`/project_detail?opportunity_id=${opportunityId}`)}>キャンセル</button>
                                                    </>
                                            }
                                        </div>
                                    </Form>
                                }
                            </div>
                        </div>
                    </div>
                </div >
            </section >
            <Footer />
        </>
    )
}

export default Contact;